export const toYesNo = (value) => (value ? 'Yes' : 'No');

export const getStoreTargetFileName = (formData = {}) => {
  const fromMedia = formData?.targetMediaFile?.[0];
  if (fromMedia) return fromMedia;
  const url = formData?.storeTargetFileUrl || '';
  if (!url) return '';
  try {
    return decodeURIComponent(new URL(url).pathname.split('/').pop() || '');
  } catch {
    return decodeURIComponent(url.split('/').pop() || '');
  }
};
